import styled from 'styled-components';
import { Layout } from 'antd';

const StyledLayoutAdmin = styled(Layout)`
  .site-layout {
    z-index: 1;
  }
`;

export { StyledLayoutAdmin };
